import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The account's own settings. Protected like every other back-office page: it acts on the
// signed-in session, so there is nothing here for someone without one.
export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/settings.tsx')),
})

// Reached only from the user menu: `NAV_ITEMS` is for sections, not for the account. The
// literal, like every other link constant here: `route.to` is still empty at module evaluation.
export const settingsLink = { to: '/settings' } as const
